module.exports = __webpack_public_path__ + "img/nocar.482556a3.png";